import { Bell } from 'lucide-react'
import { Link, useLocation } from 'react-router'

import { SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar'
import { SidebarCountBadge } from '@/components/ui/sidebar-count-badge'
import { useScopePrefix } from '@/domains/setup'

import { useUnreadCount } from './use-unread-count'

/** sidebar bell. links to the /notifications page. the command-K palette
 * keeps its own notifications section in parallel for keyboard-driven
 * quick-glance.
 */
export function BellButton() {
  const location = useLocation()
  const unreadQuery = useUnreadCount()
  const count = unreadQuery.data?.count ?? 0
  const hasUnread = count > 0
  const prefix = useScopePrefix()
  const href = `${prefix}/notifications`
  const isActive = location.pathname === href

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        asChild
        tooltip={hasUnread ? `Notifications (${count})` : 'Notifications'}
        isActive={isActive || undefined}
      >
        <Link to={href}>
          <span className='relative inline-flex'>
            <Bell />
            <SidebarCountBadge count={count} variant='dot' />
          </span>
          <span>Notifications</span>
          <SidebarCountBadge count={count} variant='pill' />
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  )
}
